import { render, staticRenderFns } from "./ScoreboardBOResumeAction.vue?vue&type=template&id=27bec21a"
import script from "./ScoreboardBOResumeAction.vue?vue&type=script&lang=js"
export * from "./ScoreboardBOResumeAction.vue?vue&type=script&lang=js"
import style0 from "./ScoreboardBOResumeAction.vue?vue&type=style&index=0&id=27bec21a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports